import { Button, Card, Group, Modal, SimpleGrid, Stack, Text, ThemeIcon } from '@mantine/core';
import { TbArrowRight, TbCloudUpload, TbUpload } from 'react-icons/tb';

const optionCardStyles = {
  border: '1px solid #eceef2',
  borderRadius: 14,
  cursor: 'pointer',
  padding: 18,
  height: '100%'
};

const OptionCard = ({ description, icon, title, onClick }) => {
  return (
    <Card withBorder shadow="sm" style={optionCardStyles} onClick={onClick}>
      <Stack gap="md" h="100%" justify="space-between">
        <Stack gap="sm">
          <ThemeIcon
            radius={12}
            size={42}
            variant="light"
            color="gray"
            styles={{ root: { backgroundColor: '#f5f6f8', color: '#111827' } }}
          >
            {icon}
          </ThemeIcon>

          <div>
            <Text fw={600} size="sm" c="dark.8" mb={4}>
              {title}
            </Text>
            <Text size="sm" c="dimmed" style={{ lineHeight: 1.5 }}>
              {description}
            </Text>
          </div>
        </Stack>

        <Group justify="space-between" wrap="nowrap">
          <Text size="xs" fw={500} c="dark.6">
            Continue
          </Text>
          <TbArrowRight size={16} color="#6b7280" />
        </Group>
      </Stack>
    </Card>
  );
};

const AddFilesSourceModal = ({
  description,
  isCloudIntegrationEnabled,
  onClose,
  onImportFromSource,
  onUploadFromDevice,
  opened,
  title
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      centered
      size="lg"
      radius={16}
      padding="lg"
      styles={{
        header: { borderBottom: '1px solid #eceef2', marginBottom: 8, paddingBottom: 16 },
        title: { fontSize: 14, fontWeight: 600 },
        body: { paddingTop: 8 }
      }}
    >
      <Stack gap="lg">
        <Text size="sm" c="dimmed" style={{ lineHeight: 1.6 }}>
          {description}
        </Text>

        <SimpleGrid cols={isCloudIntegrationEnabled ? 2 : 1} spacing="md">
          <OptionCard
            title="Upload from device"
            description="Select files from your computer and add them directly to this workspace."
            icon={<TbUpload size={20} />}
            onClick={onUploadFromDevice}
          />

          {isCloudIntegrationEnabled && (
            <OptionCard
              title="Browse connected sources"
              description="Import files from your connected Google Drive, OneDrive, or SharePoint sources."
              icon={<TbCloudUpload size={20} />}
              onClick={onImportFromSource}
            />
          )}
        </SimpleGrid>

        {isCloudIntegrationEnabled && (
          <Group justify="flex-end">
            <Button variant="default" onClick={onClose}>
              Cancel
            </Button>
          </Group>
        )}
      </Stack>
    </Modal>
  );
};

export default AddFilesSourceModal;
